// API の向き先は環境変数 REACT_APP_API_BASE_URL で切り替える。
// 本番ビルド: frontend/.env.production（コミット済み）が本番URLを供給する。
// ローカル開発: 未設定時はフォールバックの http://127.0.0.1:8000 を使用する。
const BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8000";
export default BASE_URL;

// 会社の選択肢。バックエンドの constants.COMPANY_CHOICES（OCG/NK/EHAF/ACE/TD）と
// 1対1で対応させる。
//
// Issue #123: 以前は Dashboard / HomePage / Register の3画面がそれぞれ同じ配列を
// 持っており、TD(4) の追加が Dashboard にしか反映されなかった。その結果、Export の
// 絞り込みと新規ユーザー登録から TD 社を選べない状態が残っていた。定義をこの1箇所に
// 集約し、会社の追加・改名がここだけの修正で全画面へ反映されるようにする。
export const COMPANY_CHOICES = [
	{ value: 0, label: "OCG" },
	{ value: 1, label: "NK" },
	{ value: 2, label: "EHAF" },
	{ value: 3, label: "ACE" },
	{ value: 4, label: "TD" },
];
